import {
  SET_USER,
  SET_USER_DETAILS,
  SET_USER_PROFILE,
  SET_USER_TEAM,
  SET_EDITED_PROFILE,
  SET_USER_AVATAR,
  SET_TIMESTAMP
} from '../constants/actionTypes';

import { getUser, setUserEditingData } from '../utils/apiUser';
import { REDIRECT_PATH_KEY } from '../utils/session';

/**
 * Get user data and user details data from backend services using a promise
 * and the results retrieved will be dispatched for the reducer
 * @param {function} dispatch - Dispatcher for the reducer
 */
let currentUser = null;

export const loadUser = (dispatch, history, path) => {
  getUser()
    .then(user => {
      currentUser = user;
      dispatch({ type: SET_USER, user });
    })
    .catch(error => {
      const { code } = error;
      if (code === 401) {
        if (window && window.process && window.process.type) {
          history.push('/login_widget');
        } else if (path !== '/login') {
          sessionStorage.setItem(REDIRECT_PATH_KEY, window.location.pathname);
          const location = {
            pathname: '/login',
            state: { from: { pathname: path } }
          };
          history.push(location);
        } else {
          history.push('/login');
        }
      }
    });
};

export const setUserDetail = userDetail => ({
  type: SET_USER_DETAILS,
  userDetail
});

export const setUserProfile = userProfile => ({
  type: SET_USER_PROFILE,
  userProfile
});

export const setUserTeam = userTeam => ({
  type: SET_USER_TEAM,
  userTeam
});

export const sendEditedUserData = data => {
  setUserEditingData(data);
};

export const setEditedProfile = state => ({
  type: SET_EDITED_PROFILE,
  editedProfile: state
});

export const setAvatar2Id = avatarId => ({
  type: SET_USER_AVATAR,
  avatarId
});

export const setTimeStamp = timeStamp => ({
  type: SET_TIMESTAMP,
  timeStamp
});

export const getCurrentUser = () => currentUser;
